export enum EGroupsQueryKeys {
  getGroups = "getGroups",
  getGroupById = "getGroupById",
  getGroupMembers = "getGroupMembers",
}

export const GROUPS_ENDPOINTS = {
  GROUPS: "/groups",
};
